import { Link } from "../types/cms/Link";
import { useNavigate } from "react-router-dom";

export const useNavigateToUrl = () => {
    const navigate = useNavigate();

    const navigateToUrl = (link: Link) => {
        switch (link?.type) {
            case "reference":
                navigate(link.reference?.value?.slug || "");
                break;
            case "custom":
                if (link.url?.startsWith('#')) {
                    if (window.location.pathname === '/' || window.location.pathname === '') {
                        window.location.hash = link.url;
                    } else {
                        navigate(`/${link.url}`);
                    }
                } else if (link.url?.startsWith('http')) {
                    window.location.href = link.url;
                } else {
                    navigate(link.url || "");
                }
                break;
            default:
                break;
        }

    };

    return navigateToUrl;
};